import {Injectable} from '@angular/core';
import {Area} from '../dto/area';
import {ResultForRequest} from '../dto/result-for-request';
import {Observable} from 'rxjs';
import {CatchitHttpService} from './catchit-http.service';

@Injectable({
    providedIn: 'root'
})
export class AreaService {

    constructor(private http: CatchitHttpService) {
    }

    public getById(id: number): Observable<Area> {
        return this.http.get<Area>('/areas/' + id);
    }

    public getAll(): Observable<Area[]> {
        return this.http.get<Area[]>('/areas/');
    }

    public getAllAreasByPersonId(personId: number): Observable<Area[]> {
        return this.http.get<Area[]>('/areas/person/' + personId);
    }

    public getAllAreasWherePersonHasAccessToAllLinesByPersonId(personId: number): Observable<Area[]> {
        return this.http.get<Area[]>('/areas/allLines/person/' + personId);
    }

    public getByLineId(lineId: number): Observable<Area> {
        return this.http.get<Area>('/areas/line/' + lineId);
    }

    public getAllAdminAreasByPersonId(personId: number): Observable<Area[]> {
        return this.http.get<Area[]>('/areas/admin/person/' + personId);
    }

    public update(area: Area): Observable<ResultForRequest> {
        return this.http.put<ResultForRequest>('/areas/' + area.id, area);
    }

    public create(area: Area, personId: number): Observable<ResultForRequest> {
        return this.http.post<ResultForRequest>('/areas/' + personId, area);
    }
}
